var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRadialCheck = function SvgRadialCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C3.59 0 0 3.589 0 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8Z",
    fill: "#46A2CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.45 11.703a.713.713 0 0 0 1.054-.057l4.833-5.93a.713.713 0 0 0-1.105-.9l-4.33 5.327-1.641-1.62a.713.713 0 1 0-1.002 1.013l2.191 2.167",
    fill: "#fff"
  })));
};
export default SvgRadialCheck;